export default {
  reports: 'Raporty',
  components: 'Komponenty',
};
